import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import { Link } from "react-router-dom";
// import csefaculty from "../../../assets/HODs/CSEHOD.JPG";
import mbafaculty from "../../../assets/HODs/MBA HOD.JPG";
import Accordion from "@mui/material/Accordion";
// import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Cookies from "js-cookie"
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { PageHeader } from "../../Header/PageHeader";
import "../Departments.css";
import Labs from "./Labs";
import Faculty from "../CSE/Faculty";
import axios from "axios";
import { resources } from "../../Resourses/Resources";
import Dialog from '@mui/material/Dialog';
// import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

import Slide from '@mui/material/Slide';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import icon_image from "../../../assets/Icon-2.gif"
import icon_image1 from "../../../assets/Icon-3.gif"
import { toast } from "react-toastify";

const successMessage = (message) => {
  toast.success(message, {
    position: "top-center",
    toastId: "success1",
    className: "success",
  });
};

const errorMessage = (message) => {
  toast.error(message, {
    position: "top-center",
    toastId: "error1",
    className: "error",
  });
};

// import DeleteIcon from '@mui/icons-material/Delete';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CourseStructure = () => {
  const userDetailsCookie = Cookies.get("userDetails");
  let userDetails;
  if (userDetailsCookie) {
    userDetails = JSON.parse(userDetailsCookie);
  }
  // const userName = userDetails?.username
  // const departMent = userDetails?.department
  // const userEmail = userDetails?.email
  const date = new Date()
  let academicYear1;
  const currentYear = date.getFullYear()
  const month = date.getMonth()
  if (month < 5) {
    academicYear1 = currentYear - 1 + "-" + currentYear
  } else {
    academicYear1 = currentYear + "-" + currentYear + 1

  }
  const [regulationDetails, setRegulationDetails] = useState([])
  const [fileView, setFileView] = useState(false);
  const [filepath, setFilepath] = useState("");
  const [prevObject, setPrevObject] = useState({});
  const [editFile, setEditFile] = useState(null);
  const [editpop, setEditpop] = useState(false);
  const [editRegulation, setEditRegulation] = useState({
    level: '',
    regulation: '',
    degree: '',
    branch: '',
    batch: '',
  });
  const handleClickOpen = () => {
    setFileView(true);
  };

  const handleClose = () => {
    setFileView(false);
  };
  useEffect(() => {
    // const fetchRegulationDetails = async () => {
    //   try {
    //     const response = await axios.get(resources.APPLICATION_URL + `getRegulationDetails?academicYear=${academicYear1}&branch=MBA`)
    //     console.log("response===>", response.data)
    //     setRegulationDetails(response.data)
    //   } catch (error) {
    //     console.log("error===>", error)
    //   }
    // }
    fetchRegulationDetails()
  }, [])
  const fetchRegulationDetails = async () => {
    try {
      const resp = await axios.get(resources.APPLICATION_URL + `getRegulationDetails?academicYear=${academicYear1}&branch=MBA`)
      console.log("responce===>", resp.data)
      setRegulationDetails(resp.data)
    } catch (error) {
      console.log("error===>", error)
    }
  }
  const handleDelete = async (regulation) => {
    try {
      const ress = await axios.delete(`${resources.APPLICATION_URL}deleteRegulationByObject`, {
        data: regulation
      });
      if (ress.status === 200) {
        successMessage("deleted successfully ", ress.data.message);
        fetchRegulationDetails();
      }
    } catch (error) {
      errorMessage("error")
    }

  }
  const handleEdit = async (e) => {
    e.preventDefault()


    console.log("modifieddd", editRegulation)
    console.log("prevobjjj", prevObject)

    const jsonUpdateObject = JSON.stringify(editRegulation)
    const updateObjectBlob = new Blob([jsonUpdateObject], { type: 'application/json' })

    const jsonPreObject = JSON.stringify(prevObject)
    const prevObjectBlob = new Blob([jsonPreObject], { type: 'application/json' })

    const formData = new FormData()
    formData.append('modifiedObject', updateObjectBlob)
    formData.append('previousObject', prevObjectBlob)
    // formData.append('file', editFile)
    if (editFile) {
      // New file selected — send it
      formData.append('file', editFile);
    } else {
      formData.append('file', "");
    }


    try {
      const res = await axios.put(resources.APPLICATION_URL + `regulationMaintenance/updateRegulation`, formData)
      console.log("updte call ------>>>>", res);
      if (res.status === 200) {
        setEditRegulation(res.data);
        fetchRegulationDetails()
      }
    } catch (error) {
      console.log("update call", error)
    }
  }
  return (

    <div className="containe">
      <PageHeader name="MBA - COURSE STRUCTURE" />
     {!editpop &&(
       <div className="course_structure_cnt animate__animated animate__zoomIn">
       <div className="course text-center">
         <h4>Course Structure for all Years</h4>
         <p>
           Download the Course Structure and Syllabus of four years of MBA
           course
         </p>
       </div>

       <div className="w-100 text-center d-flex justify-content-center gap-5 ">
         <table className="Department_studentDataTable" >
           <thead>
             <tr>
               <th>S.No</th>
               <th>Regulation</th>
               <th>Level</th>
               <th>Degree</th>
               <th>Batch</th>
               <th>Branch</th>
               <th>Action</th>
             </tr>
           </thead>
           <tbody>
             {regulationDetails && regulationDetails.length > 0 && regulationDetails.map((items, index) => {
               console.log("items===>", items)
               return (
                 <tr key={index}>
                   <td>{index + 1}</td>
                   <td>{items.regulation}</td>
                   <td>{items.level}</td>
                   <td>{items.degree}</td>
                   <td>{items.batch}</td>
                   <td>{items.branch}</td>
                   <td><RemoveRedEyeOutlinedIcon onClick={() => { setFileView(true); setFilepath(items.filePath) }}></RemoveRedEyeOutlinedIcon>
                     <IconButton onClick={() => {
                       setEditRegulation(items)
                       setEditpop(true)
                       console.log("responce======rrrrrrrrrrrrrrr======>", editRegulation)
                       setPrevObject(items)
                     }}>
                       <EditIcon style={{ color: "green" }} />
                     </IconButton>
                     <IconButton onClick={() => { handleDelete(items) }}>
                       <DeleteIcon style={{ color: "red" }} />
                     </IconButton>
                   </td>
                 </tr>
               )
             })}
           </tbody>
         </table>
       </div>
       <React.Fragment>
         <Dialog
           fullScreen
           open={fileView}
           onClose={handleClose}
           TransitionComponent={Transition}
           PaperProps={{
             style: {
               width: '100%',
               height: '100%',
               margin: 0,
               padding: 0,
               maxHeight: '100vh',
             },
           }}
         >
           <AppBar sx={{ position: 'relative' }}>
             <Toolbar>
               <IconButton
                 edge="start"
                 color="inherit"
                 onClick={handleClose}
                 aria-label="close"
               >
                 <CloseIcon />
               </IconButton>

             </Toolbar>
           </AppBar>
           {filepath && (
             <iframe
               src={`data:application/pdf;base64,${filepath}`}
               width="100%"
               height="100%"
             />
           )}
         </Dialog>
       </React.Fragment>
     </div>
     )}
      {editpop && (
        <div >
          <div style={{marginTop:"30px"}} >
            <div className="rgulationInputDiv">
              {/* <div className="regulationInputAndLbelDiv">
                    <label>AcademicYear</label>
                    <input type="text"  />
                </div> */}
              <div className="regulationInputAndLbelDiv">
                <label>Level</label>
                <input type="text" value={editRegulation.level} onChange={(e) => setEditRegulation({ ...editRegulation, level: e.target.value })} />
              </div>
              <div className="regulationInputAndLbelDiv">
                <label>Regulation</label>
                <input type="text" value={editRegulation.regulation} onChange={(e) => setEditRegulation({ ...editRegulation, regulation: e.target.value })} />
              </div>
              <div className="regulationInputAndLbelDiv">
                <label>Degree</label>
                <input type="text" value={editRegulation.degree} onChange={(e) => setEditRegulation({ ...editRegulation, degree: e.target.value })} />
              </div>
              <div className="regulationInputAndLbelDiv">
                <label>Branch</label>
                <input type="text" value={editRegulation.branch} onChange={(e) => setEditRegulation({ ...editRegulation, branch: e.target.value })} />
              </div>
              <div className="regulationInputAndLbelDiv">
                <label>Batch</label>
                <input type="text" value={editRegulation.batch} onChange={(e) => setEditRegulation({ ...editRegulation, batch: e.target.value })} />
              </div>
            </div>


            <div className="fileAndButtonDivRegulation">
              <div className="fileDiv" >
                <input type="file" id="regulationExcel" accept=".pdf, .docx, .doc" onChange={(e) => setEditFile(e.target.files[0])} />
                {/* {editRegulation.fileName ? (
                    <p>{editRegulation.fileName}</p>
                    ):(
                      <p>No file uploaded</p>
                    )} */}
              </div>
              <div className="fileButtons">
                <button className="uploadButton" onClick={(e) => {
                  handleEdit(e);

                  setEditpop(false);
                }}>Update</button>
                <div> <button  style={{color:"white",background:"red",fontWeight:"600",padding:"10px",borderRadius:"10px"}}onClick={() => setEditpop(false)}>close</button></div>

              </div>

            </div>

          </div>
        </div>
      )}

    </div>
  );
};
const Events = () => {
  return (
    <div className="container">
      <PageHeader name="ACTIVITIES & EVENTS" />

      <div className="course text-center animate__animated animate__fadeInRight">
        <h4>Student Development Activities</h4>
        <br />
        <p style={{ textAlign: "justify" }}>
          The Orientation Day is conducted by the college Freshman orientation
          is a way for students to meet other students, become familiar with
          campus services. Every student attending college should add
          orientation to their to-do listin college.
        </p>
      </div>
    </div>
  );
};

const Obe = () => {
  return (
    <div className="container">
      <PageHeader name="PEOs/POs/PSOs/COs" />
      <Accordion sx={{ backgroundColor: "#fff", marginBottom: "10px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="accordion_bg"
        >
          PROGRAM EDUCATIONAL OBJECTIVES(PEO)
        </AccordionSummary>
        <AccordionDetails
          align="center"
          sx={{
            backgroundColor: "#fff5dc",
            color: "#000",
            fontSize: "12px",
            fontFamily: "Arial",
            marginBottom: "10px",
            letterSpacing: "1px",
          }}
        >
          <div class="peo-container">
            <div class="peo">
              <h2>PEO 1:</h2>
              <p>
                To achieve higher levels of managerial proficiency in functional
                areas of business required for a successful career in industry,
                business, and entrepreneurship.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 2:</h2>
              <p>
                To equip the students with necessary tools and techniques for
                handling complex business problems and uncertainties.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 3:</h2>
              <p>
                To impart relevant, current and cutting-edge knowledge from the
                advanced/emerging areas of business.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 4:</h2>
              <p>
                To ignite the passion for entrepreneurship in Management
                Graduates by promoting creativity and innovation.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 5:</h2>
              <p>
                To bring out Industry-ready Management Graduates having
                necessary individual and professional competencies to excel at
                national and international level.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 6:</h2>
              <p>
                To create ethical leaders committed to the welfare of community
                and society.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 7:</h2>
              <p>
                To impart relevant, current and cutting-edge knowledge from the
                advanced/emerging areas of business.
              </p>
            </div>
            <div class="peo">
              <h2>PEO 8:</h2>
              <p>
                To promote diversity and inclusiveness in active engagement with
                community and society..
              </p>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ backgroundColor: "#fff", marginBottom: "10px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="accordion_bg"
        >
          PROGRAM OUTCOMES(PO)
        </AccordionSummary>
        <AccordionDetails
          align="center"
          sx={{
            backgroundColor: "#fff5dc",
            color: "#000",
            fontSize: "12px",
            fontFamily: "Arial",
            marginBottom: "10px",
            letterSpacing: "1px",
          }}
        >
          <div class="peo-container">
            <div class="peo">
              <h2>PO 1:</h2>
              <p>
                Analyze the Political, Economical, Social, Technological, Legal
                and Environmental context of business.
              </p>
            </div>
            <div class="peo">
              <h2>PO 2:</h2>
              <p>
                Appreciate individual ethical behavior and discharge community
                responsibilities in organization and society..
              </p>
            </div>
            <div class="peo">
              <h2>PO 3:</h2>
              <p>
                Create and deliver value to the customers by identifying their
                needs and wants.
              </p>
            </div>
            <div class="peo">
              <h2>PO 4:</h2>
              <p>
                Apply knowledge in new and unfamiliar circumstances through a
                conceptual understanding of relevant disciplines.
              </p>
            </div>
            <div class="peo">
              <h2>PO 5:</h2>
              <p>
                Adapt and find innovative methods for problem solving, to cope
                with unforeseen events, and to manage in unpredictable
                environments.
              </p>
            </div>
            <div class="peo">
              <h2>PO 6:</h2>
              <p>
                Manage contemporary societal and global issues resulting from
                diversity.
              </p>
            </div>
            <div class="peo">
              <h2>PO 7:</h2>
              <p>Demonstrate Leadership and Team work capabilities.</p>
            </div>
            <div class="peo">
              <h2>PO 8:</h2>
              <p>Improve the verbal and non-verbal communication skills.</p>
            </div>
            <div class="peo">
              <h2>PO 9:</h2>
              <p>Analyze financial statements to make investment decisions.</p>
            </div>
            <div class="peo">
              <h2>PO 10:</h2>
              <p>
                Demonstrate capabilities in new venture creation &
                entrepreneurship..
              </p>
            </div>
            <div class="peo">
              <h2>PO 11:</h2>
              <p>
                Achieve higher levels of proficiency and self-actualization
                through pursuing lifelong learning.
              </p>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ backgroundColor: "#fff", marginBottom: "10px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="accordion_bg"
        >
          PROGRAM SPECIFIC OUTCOMES (PSO)
        </AccordionSummary>
        <AccordionDetails
          align="center"
          sx={{
            backgroundColor: "#fff5dc",
            color: "#000",
            fontSize: "12px",
            fontFamily: "Arial",
            marginBottom: "10px",
            letterSpacing: "1px",
          }}
        >
          <div class="peo-container">
            <div class="peo">
              <h2>PSO 1 Practices of mathematical ideas:</h2>
              <p>
                By using mathematical techniques to solve problems using
                appropriate mathematical study, data structure and algorithms.
              </p>
            </div>
            <div class="peo">
              <h2>PSO 2 Practices Of Computing:</h2>
              <p>
                Apply modern tools, programming environments and strategies to
                develop cost effective computing solutions for complex
                engineering and real-time problems.
              </p>
            </div>
            <div class="peo">
              <h2>PSO 3 Practices of Software Development :</h2>
              <p>
                Make use of modern computer languages and environments to become
                successful software professional, an entrepreneur or zest for
                higher studies.
              </p>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ backgroundColor: "#fff", marginBottom: "10px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="accordion_bg"
        >
          COURSE STRUCTURE (CO)
        </AccordionSummary>
        <AccordionDetails
          align="center"
          sx={{
            backgroundColor: "#fff5dc",
            color: "#000",
            fontSize: "12px",
            fontFamily: "Arial",
            marginBottom: "10px",
            letterSpacing: "1px",
          }}
        >
          <div class="peo-container">
            <ul class="course_outcomes_cnt">
              <li>
                <a
                  href="https://drive.google.com/file/d/1ToJ4qNnKjBFPUDfxwIzi2wy7dk84hiWh/view"
                  target="_blank"
                >
                  R19
                </a>
              </li>
              <li>
                <a
                  href="https://drive.google.com/file/d/1PhZsGRg0F_t83BesEfmbsLqM4_oRHk8D/view"
                  target="_blank"
                >
                  R22
                </a>
              </li>
            </ul>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const AboutDepartment = () => {
  const [expanded, setExpanded] = useState(0);

  const handleAccordionChange = (index) => {
    setExpanded(index === expanded ? -1 : index);
  };

  return (
    <div>
      <div className="container">
        <PageHeader name="MASTER OF BUSINESS ADMINISTRATION (MBA)" />
        <div className="container-xxl">
          <div className="container-xxl py-5">
            <div className="container">
              <div className="row g-5">
                {/* HOD Image and Info */}
                <div
                  className="col-lg-6 wow fadeInUp"
                  data-wow-delay="0.1s"
                  style={{ minHeight: "100px" }}
                >
                  <div className="position-relative h-100 animate__animated animate__zoomIn">
                    <h6
                      style={{
                        textAlign: "center",
                        fontSize: "21px",
                        fontWeight: "bolder",
                      }}
                    >
                      HEAD OF THE DEPARTMENT - MASTER OF BUSINESS ADMINISTRATION
                    </h6>
                    <img
                      className="img-fluid rounded w-100 h-80"
                      src={mbafaculty}
                      alt="mbafaculty-img"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="img_content">
                      <p
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          paddingTop: "10px",
                        }}
                      >
                        Dr. D.N.V.KRISHNA REDDY,
                        <br />
                        HOD & Training and Placement Officer,
                        <br />
                        tpo@saispurthi.ac.in,
                        saispurthy@gmail.com,
                        <br />
                        9951006189.
                      </p>
                    </div>
                  </div>
                </div>

                {/* HOD Message */}
                <div
                  className="col-lg-6 wow fadeInUp"
                  data-wow-delay="0.3s"
                  style={{ marginTop: "140px" }}
                >
                  <h6
                    className="section-title text-start pe-3"
                    style={{ fontWeight: "Bold", fontSize: "40px" }}
                  >
                    HOD
                  </h6>
                  <h4
                    className="mb-4"
                    style={{ fontSize: "24px"}}
                  >
                    Master of Business Administration
                  </h4>

                  <div
                    className="row gy-2 gx-4 mb-4"
                    style={{ fontSize: "18px" }}
                  >
                    <p style={{ textAlign: "justify" }}>
                      The MBA program at SSIT is designed to equip students with
                      essential managerial and leadership skills. The curriculum
                      integrates theoretical knowledge with practical exposure
                      through case studies, industry interactions, and projects.
                    </p>
                    <p>
                      The department admits 60 students annually, providing
                      personalized mentoring and grooming for industry-ready
                      professionals.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vision and Mission */}
          <div className="card_cntr1">
            <div className="container">
              <div className="Home-box">
                <div className="Home-boxes1">
                  <img
                    src={icon_image}
                    height={"100px"}
                    width={"100px"}
                    alt="vision-icon"
                  />
                  <h5 className="mb-1 mt-2">Vision</h5>
                  <p style={{ textAlign: "justify", padding: "12px" }}>
                    To develop competent business leaders and entrepreneurs
                    through innovative teaching, research, and industry
                    collaboration, fostering ethical and socially responsible
                    practices.
                  </p>
                </div>
                <div className="Home-boxes2">
                  <img
                    src={icon_image1}
                    height={"100px"}
                    width={"100px"}
                    alt="mission-icon"
                  />
                  <h5 className="mb-1 mt-2">Mission</h5>
                  <p style={{ textAlign: "justify", padding: "12px" }}>
                    To impart quality management education, nurture analytical
                    thinking, enhance communication skills, and prepare students
                    for global competitiveness and sustainable business growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
 {/* <div
              className="boxes col-lg-3 text-center col-sm-6 wow "
              data-wow-delay="0.5s"
            >
              <div
                className="boxes text-center pt-3 pb-5"
                style={{ backgroundColor: "#f6f6f6", height: "fit-content" }}
              >
                <div className="p-4 ">
                  <h5 className="mb-3">STRENGTHS</h5>
                  <div>
                    <Accordion
                      sx={{ backgroundColor: "#fff", marginBottom: "10px" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        sx={{ backgroundColor: "#fff" }}
                      >
                        Infrastructure & Faculty
                      </AccordionSummary>
                      <AccordionDetails
                        align="center"
                        sx={{
                          backgroundColor: "#fff5dc",
                          color: "#000",
                          fontSize: "12px",
                          fontFamily: "Arial",
                          marginBottom: "10px",
                          letterSpacing: "1px",
                        }}
                      >
                        Ultra Modern Labs with more than 430 Systems having
                        multiple platforms like Linux, Windows and Ubuntu. 24/7
                        InternetFacility with 300 MBPS throughtwo different
                        ISPs. Well Experienced and University Ratified Faculty.
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      sx={{ backgroundColor: "#fff", marginBottom: "10px" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        Training & Placements
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          backgroundColor: "#fff5dc",
                          color: "#000",
                          fontSize: "12px",
                          fontFamily: "Arial",
                          marginBottom: "10px",
                          letterSpacing: "1px",
                        }}
                      >
                        Conducting Industry relevant Training Programmes and
                        providing Placements in various MNCs through
                        On-Campus/Off-Campus.
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                      >
                        Research & Development
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          backgroundColor: "#fff5dc",
                          color: "#000",
                          fontSize: "12px",
                          fontFamily: "Arial",
                          marginBottom: "10px",
                          letterSpacing: "1px",
                        }}
                      >
                        More than 50% Faculty Pursuing Ph.Ds from Reputed
                        Univeristies and publishing Their Research Papers in
                        Various Good Impact Journals.
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div> */}
        </div>
      </div>
    </div>
  );
};

const MBA = () => {
  const [value, setValue] = React.useState(0);
  const [departmentData, setDepartmentData] = useState([])
  const handleGetMbaDepartment = async () => {
    try {
      const res = await axios.get(
        resources.APPLICATION_URL + "getstudentdata" + "MBA"
      );
      console.log("refce", res)
      if (res.data) {
        setDepartmentData(res.data)

      }
    } catch (e) {
      console.log("MBA call Error", e);
    }
  };

  useEffect(() => {
    handleGetMbaDepartment();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider", marginTop: "35px" }}
        >
          <Tabs
            centered
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="About Department" {...a11yProps(0)} />
            <Tab label="Laboratories" {...a11yProps(1)} />
            <Tab label="Course Structure" {...a11yProps(2)} />
            <Tab label="Activities & Events" {...a11yProps(3)} />
            <Tab label="PEOs/POs/PSOs/COs" {...a11yProps(4)} />
            <Tab label="Faculty" {...a11yProps(5)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={5}>
          <Faculty />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Labs />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <CourseStructure />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <Events />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <Obe />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={0}>
          <AboutDepartment />
        </CustomTabPanel>
      </Box>
    </div>
  );
};

export default MBA;
